/* eslint-disable array-callback-return */
import { setGAEvent } from '../services/analytics/google-analytics'
import { getPopupModal } from '../services/api/requests/Explore'
import { MESSAGES } from '../services/data/profilePages.json'

const accountTypeValue = {
  guest: 0,
  basic: 1,
  advanced: 2,
}

const getPopupData = async (accountType, setPopupData, desktop) => {
  const { data } = await getPopupModal()
  const orderedData = data.sort((a, b) => a.orderNo - b.orderNo)
  const filteredData = orderedData
    .filter(popup => {
      if (popup.userTypes.includes(accountType)) return popup
    })
    .filter(popup => {
      if (desktop) {
        if (popup.desktopView) return popup
      } else {
        if (popup.mobileView) return popup
      }
    })
  await setPopupData(filteredData)
}

export const doGetPopupModal = ({
  setPopupData,
  accessToken,
  advanceAccount,
  desktop,
}) => async () => {
  try {
    if (accessToken && advanceAccount) {
      let accountType = accountTypeValue.basic
      if (advanceAccount && advanceAccount.advanced)
        accountType = accountTypeValue.advanced

      getPopupData(accountType, setPopupData, desktop)
    } else {
      getPopupData(accountTypeValue.guest, setPopupData, desktop)
    }
  } catch (error) {}
}

export const doClose = ({
  title,
  currentIndex,
  onClose,
  setDisplayPopup,
  setCurrentIndex,
}) => () => {
  onClose()
  setGAEvent('popup_modal', 'close', title, 1)
  setDisplayPopup(false)
  setCurrentIndex(currentIndex + 1)
}
const redirectOut = link => {
  const win = window && window.open(link, '_blank')
  win && win.focus()
}
const customRedirect = (link, push) => {
  const websiteUrl = process.env.REACT_APP_BASE_URL
  const pasyalUrl = '/pasyal'

  if (link.includes(websiteUrl) && !link.includes(pasyalUrl))
    push(link.split(websiteUrl)[1])
  else redirectOut(link)
}
export const doNavigate = ({
  title,
  popupType,
  deeplinkType,
  customDeeplinkUrl,
  notificationId,
  onClose,
  setDisplayPopup,
  accessToken,
  displayProfileModal,
  setProfileModalPage,
  setProfileModalDetailPage,
  push,
}) => () => {
  if (popupType === 0 && !(deeplinkType >= 0)) {
    return
  }

  switch (deeplinkType) {
    case 0:
      displayProfileModal(true)
      if (accessToken) {
        setProfileModalPage(MESSAGES)
        setProfileModalDetailPage(notificationId)
      }
      break
    case 1:
      push('/explore')
      break
    case 2:
      // ST-7046 - Rewards :: Advanced : Remove Rewards Page
      // push('/rewards')
      push('/')
      break
    case 3:
      // push('/watch')
      push('/')
      break
    case 4:
      customDeeplinkUrl
        ? customRedirect(customDeeplinkUrl, push)
        : displayProfileModal(true)
      break
    default:
  }

  onClose()
  setGAEvent('popup_modal', 'navigate', title, 1)
  setDisplayPopup(false)
}
